<template>
    <div v-if="show" class="wtc-component__spinner">
        <div class="spinner-element bg-blue-600" :class="pt.spinner"></div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from "vue";

const props = withDefaults(
    defineProps<{
        delay?: number;
        pt?: { spinner?: string };
    }>(),
    {
        delay: 250,
        pt: () => {
            return { spinner: undefined };
        }
    }
);

let tId: number;
const show = ref(false);

onMounted(() => {
    tId = window.setTimeout(() => {
        show.value = true;
    }, props.delay);
});

onUnmounted(() => {
    clearTimeout(tId);
});
</script>

<style lang="scss">
.wtc-component__spinner {
    display: flex;
    justify-content: center;
    align-items: center;

    .spinner-element {
        width: 48px;
        height: 48px;
        display: inline-block;
        position: relative;
        box-sizing: border-box;
        animation: flipX 1s linear infinite;
    }

    @keyframes flipX {
        0% {
            transform: perspective(200px) rotateX(0deg) rotateY(0deg);
        }
        50% {
            transform: perspective(200px) rotateX(-180deg) rotateY(0deg);
        }
        100% {
            transform: perspective(200px) rotateX(-180deg) rotateY(-180deg);
        }
    }
}
</style>
